"use strict";

module.exports = function () {
  this.serverSearch();
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/refresh.js